__turbopack_context__.v({
  "header": "Testimonials-module-scss-module__uX-gbq__header",
  "item": "Testimonials-module-scss-module__uX-gbq__item",
  "logo__layer": "Testimonials-module-scss-module__uX-gbq__logo__layer",
  "prev__arrow": "Testimonials-module-scss-module__uX-gbq__prev__arrow",
  "slick-list": "Testimonials-module-scss-module__uX-gbq__slick-list",
  "slick-slide": "Testimonials-module-scss-module__uX-gbq__slick-slide",
  "slick-track": "Testimonials-module-scss-module__uX-gbq__slick-track",
  "slider__arrow": "Testimonials-module-scss-module__uX-gbq__slider__arrow",
  "slider__photo": "Testimonials-module-scss-module__uX-gbq__slider__photo",
  "swiper-slide": "Testimonials-module-scss-module__uX-gbq__swiper-slide",
  "testimonial-designation": "Testimonials-module-scss-module__uX-gbq__testimonial-designation",
  "testimonial-name": "Testimonials-module-scss-module__uX-gbq__testimonial-name",
  "testimonials": "Testimonials-module-scss-module__uX-gbq__testimonials",
  "wrapper": "Testimonials-module-scss-module__uX-gbq__wrapper",
});
